<template>
    <div class="setting-right">
        <div class="setting-right-wrap wrap-boxes settings">
            <div class="page-settings">
                <div class="common-title">
                    收件地址
                </div>
                <!--<div class="line"></div>-->
                <div class="setting ">
                    <div class="contentBox">
                        <ul class="list-box clearfix">
                            <li class="add-address l" v-if="alladdresData.length < 3">
                                <div class="add-box">
                                    <p @click="dialogVisible = true" class="el-icon-plus add-btn js-add-btn"></p>
                                    <p class="add-text">添加新地址</p>
                                </div>
                            </li>
                            <li class="l add-address-data" v-for="item in alladdresData">
                                <!--<div class="normal-icon show">-->
                                <!--<span class="triangle-topright"></span>-->
                                <!--<i>默认</i>-->
                                <!--</div>-->
                                <h3 class="name">{{item.userName}}</h3>
                                <p class="phone clearfix">
                                    <span class="l detail-key">电话：</span>
                                    <span class="l detail-value">{{item.phone}}</span>
                                </p>
                                <p class="area clearfix" style="margin-top: 5px;">
                                    <span class="l detail-key">地区：</span>
                                    <span class="l detail-value">{{item.region.join('-')}}</span>
                                </p>
                                <p class="address-text clearfix" style="height: 75px;overflow-y: auto;margin-top: 5px;">
                                    <span class="l detail-key">地址：</span>
                                    <span class="l detail-value">{{item.stuaddres}}</span>
                                </p>
                                <p class="zip-code clearfix" style="margin-top: 10px;">
                                    <span class="l detail-key">邮编：</span>
                                    <span class="l detail-value">{{item.zipCode}}</span>
                                </p>
                                <div class="modify-box clearfix">
                                    <span class="js-delete-btn delete-btn r" @click="deladdres(item._id)">删除</span>
                                    <span class="js-modify-btn modify-btn r" @click="upaddres(item)">修改</span>
                                </div>
                            </li>

                        </ul>


                    </div>
                </div>
            </div>
        </div>
        <!--添加-->
        <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                width="30%"
                center
                :close-on-click-modal="false"
                :before-close="dialogClose">

            <el-form :model="addresForm" :rules="rules" ref="addresForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="姓名" prop="userName">
                    <el-input maxlength="15" placeholder="请输入收件人姓名" v-model="addresForm.userName"></el-input>
                </el-form-item>
                <el-form-item label="电话" prop="phone">
                    <el-input maxlength="11" placeholder="请输入您的手机号码"
                              v-model="addresForm.phone"></el-input>
                </el-form-item>
                <el-form-item label="城市" prop="region">
                    <el-cascader
                            expand-trigger="hover"
                            :options="options"
                            v-model="addresForm.region">
                    </el-cascader>
                </el-form-item>
                <el-form-item label="详细地址" prop="stuaddres">
                    <el-input type="textarea" placeholder="详细填写你的收件地址，如街道名称、门牌号码、楼层、房间号等信息"
                              minlength="10" maxlength="128" :rows="3" v-model="addresForm.stuaddres"></el-input>
                </el-form-item>
                <el-form-item label="邮编" prop="zipCode">
                    <el-input maxlength="6" v-model="addresForm.zipCode"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="submitForm('addresForm')">保存</el-button>
                    <el-button @click="dialogVisible = false;addresForm={};">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
    import axios from 'axios';
    import pcaa from '../assets/common/pcaa'

    export default {
        name: "site",
        components: {
            axios,
            pcaa
        },
        data() {
            return {

                addresForm: {},
                dialogVisible: false,
                options: pcaa,
                rules: {
                    userName: [
                        {required: true, message: '请输入收货人的姓名', trigger: 'blur'},
                        {min: 3, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur'}
                    ],
                    phone: [
                        {required: true, message: '请输入您的手机号码', trigger: 'blur'},
                        {min: 11, max: 11, message: '请输入正确的手机号码', trigger: 'blur'}
                    ],
                    region: [
                        {required: true, message: '请选择城市', trigger: 'blur'},
                    ],
                    stuaddres: [
                        {required: true, message: '请详细填写你的收件地址', trigger: 'blur'},
                        {min: 10, max: 128, message: '请详细填写,10 - 128 个字符', trigger: 'blur'}
                    ],
                    zipCode: [
                        {required: true, message: '请填写邮编', trigger: 'blur'},
                        {min: 6, max: 6, message: '请正确填写邮编', trigger: 'blur'}
                    ],
                },
                alladdresData: [],
            };
        },
        methods: {

            submitForm(addresForm) {
                this.$refs[addresForm].validate((valid) => {
                    if (valid) {
                        axios.post("/Api/admin/addaddres", this.addresForm).then(res => {
                            if (res.statusText == "OK") {
                                if (res.data.errcode == 0) {
                                    this.addresForm = {};
                                    this.dialogVisible = false;
                                    this.$message({
                                        showClose: true,
                                        message: res.data.message,
                                        type: 'success',
                                        duration: 5000
                                    });
                                    this.getAlladdres();
                                } else if (res.data.errcode == 4000) {
                                    //请先登入
                                    this.$message({
                                        showClose: true,
                                        message: '请先登入！',
                                        type: 'error',
                                        duration: 10000
                                    });
                                    this.$router.push({
                                        name: 'Cart',
                                    });
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.data.message,
                                        type: 'error',
                                        duration: 5000
                                    });
                                }
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: '添加收件地址失败',
                                    type: 'error',
                                    duration: 5000
                                });
                            }
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: '请填写正确的数据',
                            type: 'error',
                            duration: 5000
                        });
                        return false;
                    }
                });
            },
            dialogClose() {
                this.addresForm = {};
                this.dialogVisible = false;
            },
            //获取所有的邮寄数据
            getAlladdres() {
                axios.post("/Api/admin/getALLaddres").then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.alladdresData = res.data.data;
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error',
                                duration: 5000
                            });
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: '获取数据失败',
                            type: 'error',
                            duration: 5000
                        });
                    }
                });
            },
            //删除
            deladdres(id) {
                this.$confirm('确定删除此邮寄地址吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.post("/Api/admin/deladdres", {'id': id}).then(res => {
                        if (res.statusText == "OK") {
                            if (res.data.errcode == 0) {
                                this.getAlladdres();
                                this.$message({
                                    showClose: true,
                                    type: 'success',
                                    message: '删除成功!',
                                    duration: 5000
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.data.message,
                                    type: 'error',
                                    duration: 5000
                                });
                            }
                        } else {
                            this.$message({
                                showClose: true,
                                message: '删除数据失败',
                                type: 'error',
                                duration: 5000
                            });
                        }
                    });

                }).catch(() => {

                });
            },
            //修改
            upaddres(data) {
                this.addresForm = data;
                this.dialogVisible = true;
            },
        },
        mounted() {
            this.getAlladdres();
            // var alldata = [];
            // var sheng = pcaa["86"]; // 省
            // for (var key in sheng) {
            //     var shengs = pcaa[key];
            //     var shishuju = [];
            //     for (var obj in shengs) {
            //         var shengss = pcaa[obj];// 临淄区市
            //         var qushuju = [];
            //         for (var dt in shengss) {
            //             qushuju.push({value: shengss[dt], label: shengss[dt]});
            //         }
            //         shishuju.push({value: shengs[obj], label: shengs[obj], children: qushuju});
            //     }
            //     alldata.push({value: sheng[key], label: sheng[key], children: shishuju});
            // }
            // console.log(JSON.stringify(alldata))
            // this.options = alldata;
        },
    }
</script>

<style>
    .setting-right .el-cascader {
        width: 100% !important;
    }

    .setting-right {
        float: left;
        margin-left: 48px;
        width: 960px;
        box-sizing: border-box;
        /*background-color: #fff;*/
    }

    .setting-right-wrap {
        min-height: 550px;
    }

    .common-title {
        line-height: 40px;
        font-size: 16px;
        font-weight: 700;
    }

    /*.line {*/
    /*height: 1px;*/
    /*background-color: #d0d6d9;*/
    /*margin-top: 12px;*/
    /*}*/

    .contentBox .list-box {
        padding: 0 4px;
        margin-top: 24px;
    }

    .contentBox .list-box .add-address {
        text-align: center;
        background-color: #fff;
    }

    .add-address-data {
        background-color: #fff;
    }

    .add-address-data:hover .modify-box {
        display: block !important;
    }

    .contentBox .list-box .add-address .add-btn {
        width: 50px;
        height: 50px;
        margin: 46px auto 0;
        text-align: center;
        color: #fff;
        background: #d9dde1;
        font-size: 20px;
        font-weight: 700;
        padding: 15px;
        box-sizing: border-box;
        border-radius: 50%;
        cursor: pointer;
    }

    .contentBox .list-box .add-address .add-text {
        text-align: center;
        font-size: 14px;
        color: #4d555d;
        margin-top: 18px;
    }

    .contentBox .list-box li {
        position: relative;
        margin-right: 20px;
        margin-bottom: 20px;
        padding: 24px;
        width: 296px;
        height: 260px;
        border: 1px solid #d0d6d9;
        box-sizing: border-box;
    }

    .contentBox .list-box li h3 {
        margin-bottom: 10px;
        font-size: 16px;
        color: #07111b;
        font-weight: 700;
    }

    .contentBox .list-box li .address-text, .contentBox .list-box li .area, .contentBox .list-box li .phone, .contentBox .list-box li .zip-code {
        font-size: 14px;
        color: #4d555d;
    }

    .contentBox .list-box li .modify-box {
        display: none;
        /*position: absolute;*/
        font-size: 12px;
        color: #f01414;
        bottom: 16px;
        right: 20px;
    }

    .contentBox .list-box li .modify-box span {
        cursor: pointer;
    }

    .contentBox .list-box li .modify-box .modify-btn {
        margin-right: 22px;
        margin-left: 80px;
    }

    .contentBox .list-box li .address-text .detail-value, .contentBox .list-box li .area .detail-value, .contentBox .list-box li .phone .detail-value, .contentBox .list-box li .zip-code .detail-value {
        max-width: 188px;
        /*word-break: break-word;*/
    }
</style>